export default {
  namespaced: true,
  state: {
    loadingStatus: false,
    visible: false,
    progress: 0,
  },
  getters: {
    loadingStatus: state => state.loadingStatus,
    visible: state => state.visible,
    progress: state => state.progress,
  },
  mutations: {
    ['SET_LOADING_STATUS'] (state, data) {
      state.loadingStatus = data;
    },
    ['SET_VISIBLE'] (state, data) {
      state.visible = data;
    },
    ['SET_PROGRESS'] (state, data) {
      state.progress = data;
    },
  },
  actions: {

  }
}
